/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForAIPromptAnalyticsGcp extends models.GovernanceConfigurationBaseForAIPromptAnalytics {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForAIPromptAnalyticsGcp");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForAIPromptAnalyticsGcp.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForAIPromptAnalyticsGcp>): GovernanceConfigurationForAIPromptAnalyticsGcp {
        let obj = Object.assign(new GovernanceConfigurationForAIPromptAnalyticsGcp(), model);
        GovernanceConfigurationForAIPromptAnalyticsGcp.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForAIPromptAnalyticsGcp>): GovernanceConfigurationForAIPromptAnalyticsGcp {
        if (!model) return null;
        return GovernanceConfigurationForAIPromptAnalyticsGcp.newInstance(<GovernanceConfigurationForAIPromptAnalyticsGcp> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForAIPromptAnalyticsGcp) {
        if (!obj) return;

        models.GovernanceConfigurationForAIPromptAnalyticsGcp.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForAIPromptAnalyticsGcp): boolean {
        if (models.GovernanceConfigurationBaseForAIPromptAnalytics.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForAIPromptAnalyticsGcp.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * BigQuery dataset id
     */
    dataset_id: string;

    /**
     * BigQuery table id
     */
    table_id: string;

}
